import React from 'react';

interface ScannerFooterProps {
  device: string;
  list: { generated_at: string } | null;
  onRefresh: () => void;
}

function formatTime(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function ScannerFooter({
  device,
  list,
  onRefresh,
}: ScannerFooterProps): JSX.Element {
  return (
    <p
      style={{
        fontSize: 12,
        color: 'rgba(255,255,255,.4)',
        textAlign: 'center',
      }}
    >
      {device} · liste mise à jour {list ? formatTime(list.generated_at) : '—'}
      {' · '}
      <button
        type="button"
        onClick={onRefresh}
        style={{
          background: 'none',
          border: 0,
          color: 'inherit',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        actualiser
      </button>
    </p>
  );
}

export default ScannerFooter;
